import { useMemo } from 'react';
import { useGetRecentColleagueFeedbackQuery } from '../api/colleagueFeedbackApi';
import { FEEDBACK_PAGE_SIZE } from '../constants';
import { mapRecentToFeedbackEntries } from '../helpers/mapFeedbackEntries';

export function useFeedbackEntries(page: number, enabled: boolean) {
  const {
    data: recent,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetRecentColleagueFeedbackQuery(
    { page, pageSize: FEEDBACK_PAGE_SIZE },
    { skip: !enabled }
  );

  const entries = useMemo(() => mapRecentToFeedbackEntries(recent?.items ?? []), [recent]);

  const totalCount = recent?.totalCount ?? 0;

  return { entries, totalCount, isLoading, isFetching, isError, refetch };
}
